import { css } from "lit";
import { baseStyles } from "../../theme/theme";

export const eventsStyles = [
  baseStyles,
  css`
    .wrap {
      max-width: 1080px;
      margin: 0 auto;
      padding: 2rem 2rem 5rem;
    }
    @media (max-width: 760px) {
      .wrap {
        padding: 1.25rem 1rem 4rem;
      }
    }
    .filters {
      display: flex;
      justify-content: center;
      gap: 0.5rem;
      flex-wrap: wrap;
      margin-bottom: 1.5rem;
    }
    .tz-row {
      display: flex;
      justify-content: center;
      margin-bottom: 0.75rem;
    }
    .tz-pill {
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
      border: 1px solid var(--zui-line);
      border-radius: 999px;
      padding: 0.25rem 0.65rem 0.25rem 0.5rem;
      background: #fff;
    }
    .tz-pill select {
      border: none;
      background: transparent;
      font: inherit;
      font-size: 12px;
      color: var(--zui-panel-ink);
      cursor: pointer;
    }
    .tz-pill select:focus-visible {
      outline: none;
    }
    .pill {
      position: relative;
      display: inline-flex;
    }
    .pill select {
      appearance: none;
      font: inherit;
      font-size: 13px;
      font-weight: 600;
      padding: 0.5rem 2rem 0.5rem 0.875rem;
      border: 1px solid var(--zui-line);
      /* X2: "square" flattens the filter controls too; rounded/pill/unset
           keep the pill shape via the var() fallback. */
      border-radius: var(--zui-square-radius, 999px);
      background: #fff;
      color: var(--zui-panel-ink);
      cursor: pointer;
    }
    .pill.active select {
      background: var(--zui-accent-soft);
      border-color: var(--zui-accent);
      color: var(--zui-accent-deep);
    }
    .pill .chev {
      position: absolute;
      right: 0.7rem;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      color: var(--zui-panel-ink-soft);
      display: inline-flex;
    }
    .month-divider {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      margin: 0.375rem 0;
    }
    .month-divider span.lbl {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      color: var(--zui-panel-ink-soft);
    }
    .month-divider span.rule {
      flex: 1;
      height: 1px;
      background: var(--zui-line);
    }
    .list {
      display: flex;
      flex-direction: column;
      gap: 1.375rem;
      margin-top: 0.75rem;
    }
    .card {
      display: flex;
      align-items: stretch;
      border: 1px solid var(--zui-line);
      /* X2: "square" flattens the event cards too (thumbnail corners follow
           via overflow:hidden); rounded/pill/unset keep the theme radius. */
      border-radius: var(--zui-square-radius, var(--zui-radius));
      background: #fff;
      overflow: hidden;
      transition:
        transform 0.18s ease,
        border-color 0.18s ease,
        box-shadow 0.18s ease;
    }
    .card:hover {
      border-color: var(--zui-accent);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px -8px rgba(31, 42, 34, 0.35);
    }
    .thumb {
      position: relative;
      flex: 0 0 auto;
      width: 280px;
      /* Item 9: below large desktop the card grows taller as its content
           wraps, but a fixed aspect-ratio thumbnail stays short and leaves an
           empty band beside it. Default to stretching the thumbnail to the
           card's full height (align-self: stretch) and drop the configured
           ratio (aspect-ratio: auto) so the cover image — which is
           position:absolute; inset:0 — fills the vertical space edge-to-edge.
           The configured thumbnailRatio is injected inline as the
           --thumb-ratio custom property and is honored only at large-desktop
           widths (see the min-width:1024px block below); on mobile it returns
           as a full-width banner (see the max-width blocks). */
      align-self: stretch;
      aspect-ratio: auto;
      background: var(--zui-accent-soft);
    }
    .thumb img {
      /* EV-THUMB: fill the aspect-ratio box edge-to-edge. The container owns
           the ratio (inline aspect-ratio + width); an in-flow img with
           height:100% can't resolve its height against a flex item whose own
           height is content/aspect-ratio-derived (align-self:flex-start), so it
           fell back to the image's intrinsic ratio and letterboxed (revealing
           the accent-soft background). Absolutely filling the (position:relative)
           container decouples it from that circular sizing. */
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    /* Item 9: only on large desktop (near the layout's 1080px max width) does
         the thumbnail hold the configured thumbnailRatio as a fixed-width
         aspect-ratio box pinned to the top of the card. Below this the base
         .thumb rule lets it stretch to the card's full height instead, so a
         card grown by wrapping text has no empty band beside the image. The
         inline-injected --thumb-ratio custom property (rather than a raw inline
         aspect-ratio) lets this media query re-enable the ratio without
         !important. */
    @media (min-width: 1024px) {
      .thumb {
        align-self: flex-start;
        aspect-ratio: var(--thumb-ratio, 3 / 2);
      }
    }
    .date-tag {
      position: absolute;
      top: 12px;
      left: 12px;
      background: var(--zui-bg);
      /* EV-SQ: "square" flattens the date tag too (like .card/.thumb);
           rounded/pill/unset keep the 8px tag radius via the var() fallback. */
      border-radius: var(--zui-square-radius, 8px);
      padding: 4px 8px 5px;
      min-width: 46px;
      text-align: center;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
      /* Connie 7/20: date tag border follows embed accent (was default blue). */
      border: 1px solid var(--zui-accent);
    }
    .date-tag .m {
      font-size: 9.5px;
      font-weight: 700;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: var(--zui-accent);
      line-height: 1;
    }
    .date-tag .d {
      font-family: var(--zui-font);
      font-weight: 800;
      font-size: 17px;
      color: var(--zui-accent-deep, var(--zui-accent));
      line-height: 1;
      margin-top: 0;
    }
    .body {
      flex: 1;
      padding: 1.875rem 1.75rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      min-width: 0;
    }
    .when {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      flex-wrap: wrap;
      font-size: 11.5px;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: var(--zui-accent);
    }
    .when .sep {
      opacity: 0.6;
    }
    .ename {
      font-family: var(--zui-font);
      font-weight: var(--zui-weight, 500);
      font-size: 20px;
      letter-spacing: -0.01em;
      line-height: 1.2;
      color: var(--zui-panel-ink);
    }
    .summary {
      font-size: 13.5px;
      line-height: 1.35;
      color: var(--zui-panel-ink-soft);
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .loc {
      margin-top: 4px;
      font-size: 13px;
      color: var(--zui-accent);
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }
    .aside {
      flex: 0 0 auto;
      padding: 1.875rem 1.75rem;
      border-left: 1px solid var(--zui-line);
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;
      gap: 0.625rem;
      min-width: 150px;
    }
    .price {
      font-family: var(--zui-font);
      font-weight: var(--zui-weight, 500);
      font-size: 22px;
      letter-spacing: -0.01em;
      color: var(--zui-panel-ink);
      line-height: 1;
    }
    .reg {
      appearance: none;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: var(--zui-accent);
      color: var(--zui-btn-text);
      border: 0;
      border-radius: var(--zui-btn-radius, 10px);
      padding: 12px 18px;
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      white-space: nowrap;
    }
    .empty {
      border: 1px dashed var(--zui-line);
      border-radius: var(--zui-radius);
      padding: 2.5rem 1.5rem;
      text-align: center;
      color: var(--zui-panel-ink-soft);
      font-size: 0.9rem;
    }
    .empty button {
      display: block;
      margin: 0.75rem auto 0;
      appearance: none;
      background: none;
      border: 0;
      color: var(--zui-accent);
      font: inherit;
      font-weight: 700;
      cursor: pointer;
    }
    /* Detail view */
    .back {
      appearance: none;
      background: none;
      border: 0;
      color: var(--zui-accent);
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font: inherit;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      padding: 4px 0;
      margin-bottom: 1.125rem;
    }
    .hero {
      border-radius: var(--zui-radius);
      overflow: hidden;
      margin-bottom: 1.5rem;
      background: var(--zui-accent-soft);
      aspect-ratio: 16 / 7;
      max-height: 380px;
    }
    .hero img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .detail-grid {
      display: grid;
      grid-template-columns: 1.4fr 1fr;
      gap: 2rem;
      align-items: start;
    }
    @media (max-width: 760px) {
      .detail-grid {
        grid-template-columns: 1fr;
        gap: 1.125rem;
      }
      .card {
        flex-direction: column;
      }
      .thumb {
        width: 100%;
        /* Full-width banner on mobile; restore the configured thumbnailRatio
             (dropped by the base rule) via --thumb-ratio so it drives the
             height in the column layout. */
        align-self: stretch;
        aspect-ratio: var(--thumb-ratio, 3 / 2);
      }
      .aside {
        border-left: 0;
        border-top: 1px solid var(--zui-line);
        align-items: stretch;
      }
    }
    .dtitle {
      margin: 0;
      font-family: var(--zui-font);
      font-weight: var(--zui-weight, 500);
      font-size: 36px;
      letter-spacing: -0.02em;
      color: var(--zui-headline);
      line-height: 1.1;
    }
    .metas {
      margin-top: 14px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .meta {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      font-size: 14px;
      font-weight: 600;
      color: var(--zui-headline);
    }
    .meta .ic {
      flex: 0 0 auto;
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background: var(--zui-accent-soft);
      color: var(--zui-accent-deep);
      display: grid;
      place-items: center;
    }
    .meta .sub {
      font-size: 13px;
      font-weight: 500;
      color: var(--zui-panel-ink-soft);
      margin-top: 1px;
    }
    .divider {
      height: 1px;
      background: var(--zui-line);
      margin: 20px 0;
    }
    .dh2 {
      margin: 0;
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 19px;
      letter-spacing: -0.01em;
      color: var(--zui-headline);
    }
    .dbody {
      margin: 10px 0 0;
      font-size: 14.5px;
      line-height: 1.6;
      color: var(--zui-panel-ink-soft);
      white-space: pre-line;
      overflow-wrap: anywhere;
    }
    .daddr {
      font-size: 14px;
      color: var(--zui-panel-ink-soft);
      margin: 10px 0;
    }
    .loc-detail {
      font-size: 14px;
      line-height: 1.35;
      color: var(--zui-headline);
    }
    .loc-detail .sub {
      color: var(--zui-panel-ink-soft);
      margin-top: 2px;
    }
    .maplink {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      font-weight: 600;
      color: var(--zui-accent);
      text-decoration: none;
    }
    .aside-col {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }
    .pcard {
      border: 1px solid var(--zui-line);
      border-radius: var(--zui-radius);
      background: #fff;
      padding: 1.375rem;
    }
    .pcard .ov {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: var(--zui-panel-ink-soft);
    }
    .pcard .big {
      margin-top: 4px;
      font-family: var(--zui-font);
      font-weight: var(--zui-weight, 500);
      font-size: 36px;
      letter-spacing: -0.02em;
      color: var(--zui-panel-ink);
      line-height: 1;
    }
    .pcard .note {
      margin-top: 6px;
      font-size: 13px;
      color: var(--zui-panel-ink-soft);
    }
    .pcard .reg {
      margin-top: 18px;
    }
    .hosted .ho {
      margin-top: 8px;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .hosted .avatar {
      width: 38px;
      height: 38px;
      border-radius: 10px;
      background: var(--zui-accent);
      color: var(--zui-btn-text);
      display: grid;
      place-items: center;
      font-family: var(--zui-font);
      font-weight: 800;
      font-size: 15px;
      flex: 0 0 auto;
    }
    .hosted .hname {
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 14.5px;
      color: var(--zui-panel-ink);
    }
    .hosted .hloc {
      font-size: 12.5px;
      color: var(--zui-accent);
      font-weight: 600;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-top: 2px;
    }
    .share-row {
      display: flex;
      gap: 8px;
    }
    .share {
      flex: 1;
      appearance: none;
      background: #fff;
      color: var(--zui-panel-ink);
      border: 1px solid var(--zui-line);
      border-radius: var(--zui-btn-radius, 10px);
      padding: 10px 12px;
      font: inherit;
      font-size: 12.5px;
      font-weight: 600;
      letter-spacing: 0.04em;
      cursor: pointer;
    }
    /* Register Now anchor (left column of detail) */
    .register-now {
      margin-top: 1rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      text-decoration: none;
      background: var(--zui-accent);
      color: var(--zui-btn-text);
      border-radius: var(--zui-btn-radius, 10px);
      padding: 0.8rem 1.5rem;
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.03em;
      cursor: pointer;
      border: 0;
    }
    /* Inline register checkout */
    .register {
      margin-top: 2.5rem;
      scroll-margin-top: 1rem;
    }
    .register > .divider {
      margin-bottom: 1.75rem;
    }
    /* Headline row: "Register" on the left, the secondary "Sign in" action
         right-aligned on the SAME line (7/25 QA — it used to be a link-styled
         button trailing the microcopy inside step 1, where it read as fine
         print and was easy to miss).

         'flex-wrap' rather than a width breakpoint: the embed is a custom
         element sized by whatever container the host page drops it in, so a
         viewport media query cannot tell how much room this row actually has.
         Wrapping lets the action drop onto its own line exactly when the
         headline no longer fits beside it, at any embed width. */
    .register .rh-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.5rem 1rem;
      margin: 0 0 1rem;
    }
    .register h2.rh {
      font-family: var(--zui-font);
      font-weight: var(--zui-weight, 500);
      font-size: 26px;
      letter-spacing: -0.02em;
      color: var(--zui-headline);
      margin: 0;
      /* Shrink/wrap the headline instead of pushing the action out of the
           row (a flex item's min-width defaults to its min-content size). */
      min-width: 0;
      overflow-wrap: anywhere;
    }
    /* Prompt + button travel together so they wrap as one unit. */
    .register .signin-cta {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.5rem 0.75rem;
      margin-left: auto;
    }
    .register .signin-cta-t {
      font-size: 13px;
      color: var(--zui-panel-ink-soft);
    }
    .reg-grid {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 320px;
      gap: 1.75rem;
      align-items: start;
    }
    @media (max-width: 760px) {
      .reg-grid {
        grid-template-columns: 1fr;
      }
      /* EV4/X2: on mobile put the Order Summary ABOVE the steps + payment
           instead of below (DOM order is steps → summary). */
      .reg-grid > .steps {
        order: 2;
      }
      .reg-grid > .esummary {
        order: 1;
      }
    }
    .steps {
      display: flex;
      flex-direction: column;
      gap: 0.875rem;
      min-width: 0;
    }
    .estep {
      background: #fff;
      border: 1px solid var(--zui-line);
      border-radius: 14px;
      padding: 1.125rem 1.25rem;
      transition:
        box-shadow 0.15s ease,
        border-color 0.15s ease;
    }
    .estep.open {
      border-color: var(--zui-accent);
      box-shadow: 0 0 0 3px var(--zui-accent-soft);
    }
    .estep-head {
      display: flex;
      align-items: center;
      gap: 0.7rem;
      cursor: pointer;
    }
    .estep .num {
      width: 26px;
      height: 26px;
      border-radius: 999px;
      display: grid;
      place-items: center;
      font-size: 0.8rem;
      font-weight: 700;
      /* Neutralize host-page line-height so the number glyph sits dead-center
           in the circle instead of riding high (equal top/bottom). See EV2/X3. */
      line-height: 1;
      background: transparent;
      color: var(--zui-panel-ink-soft);
      border: 1px solid var(--zui-line);
      flex: 0 0 auto;
    }
    .estep .num.open {
      background: var(--zui-accent);
      color: var(--zui-btn-text);
      border-color: var(--zui-accent);
    }
    .estep .num.done {
      background: #3a7a4d;
      color: #fff;
      border-color: #3a7a4d;
    }
    .estep .st {
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 16px;
      color: var(--zui-headline);
    }
    .estep .edit {
      margin-left: auto;
      appearance: none;
      background: none;
      border: 0;
      color: var(--zui-accent);
      font: inherit;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      cursor: pointer;
    }
    .estep .ssum {
      font-size: 13px;
      color: var(--zui-panel-ink-soft);
      margin: 0.3rem 0 0 2.1rem;
    }
    .estep-body {
      margin: 0.85rem 0 0;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
    }
    .efield {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      font-size: 0.78rem;
      font-weight: 600;
      color: var(--zui-panel-ink-soft);
    }
    .efield input {
      padding: 0.6rem 0.7rem;
      border: 1.5px solid var(--zui-line);
      border-radius: 12px;
      background: var(--zui-panel);
      color: var(--zui-headline);
      font: inherit;
      font-size: 15px;
    }
    .efield input:focus {
      outline: none;
      border-color: var(--zui-accent);
      box-shadow: 0 0 0 3px var(--zui-accent-soft);
    }
    .ticket-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.75rem;
      border: 1px solid var(--zui-line);
      border-radius: 10px;
      padding: 0.75rem 0.875rem;
    }
    .ticket-row .t {
      font-size: 13.5px;
      font-weight: 700;
      color: var(--zui-headline);
    }
    .ticket-row .s {
      font-size: 12px;
      color: var(--zui-panel-ink-soft);
    }
    .qstep {
      display: inline-flex;
      align-items: center;
      gap: 0.6rem;
    }
    .qstep button {
      width: 32px;
      height: 32px;
      border-radius: 999px;
      border: 1px solid var(--zui-accent);
      background: #fff;
      color: var(--zui-accent-deep);
      cursor: pointer;
      font: inherit;
      font-size: 1.1rem;
      /* EV-WAIVER (N5): center the −/+ glyph dead-center in the circular
           button. Without an explicit flex box + line-height:1 the glyph
           inherits the host page's line-height and rides high/off-center
           (same fix as the .num circle). */
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      padding: 0;
    }
    .qstep .n {
      font-family: var(--zui-font);
      font-weight: 700;
      min-width: 1.5rem;
      padding: 0 0.15rem;
      text-align: center;
    }
    .guests-h {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: var(--zui-panel-ink-soft);
    }
    .guest-card {
      border: 1px solid var(--zui-line);
      border-radius: 10px;
      background: var(--zui-panel);
      padding: 0.875rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .guest-card .gh {
      font-size: 12px;
      font-weight: 700;
      color: var(--zui-panel-ink);
    }
    .ewaiver {
      border: 1px solid var(--zui-line);
      border-radius: 12px;
      overflow: hidden;
      background: var(--zui-bg);
    }
    .ewaiver-head {
      display: flex;
      align-items: center;
      gap: 0.625rem;
      width: 100%;
      appearance: none;
      background: none;
      border: 0;
      text-align: left;
      cursor: pointer;
      padding: 0.75rem 0.875rem;
      font: inherit;
    }
    .ewaiver-head .ic {
      width: 28px;
      height: 28px;
      border-radius: 8px;
      background: var(--zui-accent-soft);
      color: var(--zui-accent-deep);
      display: grid;
      place-items: center;
      flex: 0 0 auto;
    }
    .ewaiver-head .wt {
      font-size: 13.5px;
      font-weight: 700;
      /* EV-WAIVER: neutralize the host page's line-height so the title and its
           subline sit as a tight label pair instead of double-spaced. */
      line-height: 1.3;
      color: var(--zui-headline);
    }
    .ewaiver-head .ws {
      font-size: 11.5px;
      line-height: 1.3;
      color: var(--zui-panel-ink-soft);
    }
    .ewaiver-head .chev {
      margin-left: auto;
      color: var(--zui-panel-ink-soft);
      transition: transform 0.2s ease;
    }
    .ewaiver-head .chev.open {
      transform: rotate(180deg);
    }
    .ewaiver-body {
      max-height: 180px;
      overflow: auto;
      padding: 0 0.875rem 0.875rem;
      font-size: 13px;
      /* EV-WAIVER: tighten the agreement-text leading (was 1.55). */
      line-height: 1.4;
      color: var(--zui-panel-ink-soft);
    }
    .ewaiver-check {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      padding: 0.75rem 0.875rem;
      border-top: 1px solid var(--zui-line);
      font-size: 12.5px;
      line-height: 1.4;
      color: var(--zui-headline);
    }
    .ewaiver-check input {
      /* EV-WAIVER: keep the checkbox fixed-size and nudge it onto the first
           line's optical center so the consent copy aligns with the box. */
      flex: 0 0 auto;
      margin: 2px 0 0;
    }
    .free-note {
      padding: 0.875rem 1rem;
      border-radius: 10px;
      background: var(--zui-accent-soft);
      color: var(--zui-headline);
      font-size: 13.5px;
      line-height: 1.5;
    }
    .estep .cta {
      appearance: none;
      cursor: pointer;
      border: 0;
      background: var(--zui-accent);
      color: var(--zui-btn-text);
      font-family: var(--zui-font);
      font-weight: 700;
      border-radius: var(--zui-btn-radius, 10px);
      padding: 0.8rem 1.5rem;
      align-self: flex-end;
    }
    .estep .cta.block {
      width: 100%;
      align-self: stretch;
    }
    .estep .cta:disabled {
      background: #d8d6cf;
      cursor: default;
    }
    .esummary {
      position: sticky;
      top: 1rem;
      border: 1px solid var(--zui-line);
      border-radius: 14px;
      background: #fff;
      padding: 1.25rem;
    }
    @media (max-width: 760px) {
      .esummary {
        position: static;
        margin-bottom: 1rem;
      }
    }
    .esummary h3 {
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 18px;
      letter-spacing: -0.01em;
      margin: 0 0 1rem;
      color: var(--zui-headline);
    }
    .esum-li {
      display: flex;
      justify-content: space-between;
      gap: 0.5rem;
      font-size: 0.85rem;
      padding: 0.2rem 0;
      color: var(--zui-panel-ink);
    }
    .esum-total {
      display: flex;
      justify-content: space-between;
      font-family: var(--zui-font);
      font-weight: 800;
      font-size: 1.05rem;
      margin-top: 0.5rem;
      padding-top: 0.5rem;
      border-top: 1px solid var(--zui-line);
      color: var(--zui-headline);
    }
    .placed {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      gap: 0.5rem;
      padding: 2.5rem 1.5rem;
    }
    .co {
      padding: 0 1.25rem 1.25rem;
      display: flex;
      flex-direction: column;
      gap: 0.7rem;
    }
    .co h3 {
      margin: 0;
      color: var(--zui-headline);
    }
    .co label.fld {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      font-size: 0.78rem;
      color: var(--zui-details);
    }
    .co input {
      padding: 0.5rem 0.6rem;
      border: 1px solid var(--zui-line);
      border-radius: var(--zui-radius);
      background: var(--zui-bg);
      color: var(--zui-headline);
      font: inherit;
    }
    .co .grid2 {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.6rem;
    }
    .co .stepper {
      display: inline-flex;
      align-items: center;
      gap: 0.6rem;
    }
    .co .stepper button {
      width: 28px;
      height: 28px;
      border-radius: 999px;
      border: 1px solid var(--zui-line);
      background: var(--zui-bg);
      color: var(--zui-headline);
      cursor: pointer;
      font: inherit;
      /* EV-WAIVER (N5): same dead-center treatment as .qstep button. */
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      padding: 0;
    }
    .co .guest {
      border: 1px solid var(--zui-line);
      border-radius: var(--zui-radius);
      padding: 0.6rem;
    }
    .co .toggle-line {
      display: flex;
      gap: 0.5rem;
      align-items: flex-start;
      font-size: 0.82rem;
      color: var(--zui-headline);
    }
    .co .sum {
      display: flex;
      justify-content: space-between;
      font-weight: 800;
      border-top: 1px solid var(--zui-line);
      padding-top: 0.5rem;
      color: var(--zui-headline);
    }
    @media (max-width: 640px) {
      .card {
        flex-direction: column;
      }
      .thumb {
        width: 100%;
        /* Restore the configured thumbnailRatio (dropped by the base rule)
             via --thumb-ratio so it drives the height in the full-width column
             layout instead of stretching. */
        align-self: stretch;
        aspect-ratio: var(--thumb-ratio, 3 / 2);
      }
      .aside {
        border-left: 0;
        border-top: 1px solid var(--zui-line);
        align-items: stretch;
      }
    }
  `,
];
